// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__Zl78X","rootCenter":"LoadMoreObserver_rootCenter__36r20","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2BDS9"};